// Mã thu hồi / hết hạn không bao giờ thành "đã dùng" nên không tính vào số mã khả dụng.
export const getUsableCodes = (batch) =>
  Math.max(0, (batch.total_codes || 0) - (batch.revoked_codes || 0) - (batch.expired_codes || 0));

export const getUsageRate = (batch) => {
  const usable = getUsableCodes(batch);
  if (usable === 0) return 0;
  return Math.min(100, Math.round(((batch.used_codes || 0) / usable) * 100));
};

const STATUSES = {
  expired: { label: 'Hết hạn', className: 'text-gray-600 bg-gray-100' },
  revoked: { label: 'Đã thu hồi', className: 'text-red-600 bg-red-100' },
  notUsed: { label: 'Chưa sử dụng', className: 'text-blue-600 bg-blue-100' },
  inUse: { label: 'Đang sử dụng', className: 'text-orange-600 bg-orange-100' },
  usedUp: { label: 'Đã dùng hết', className: 'text-green-600 bg-green-100' },
};

export const getBatchStatus = (batch, now = new Date()) => {
  if (batch.expires_at && new Date(batch.expires_at) < now) return STATUSES.expired;

  const used = batch.used_codes || 0;
  const usable = getUsableCodes(batch);
  // Thu hồi hết mà chưa ai dùng thì không phải "Chưa sử dụng".
  if (used === 0) return usable === 0 && batch.total_codes > 0 ? STATUSES.revoked : STATUSES.notUsed;
  if (used >= usable) return STATUSES.usedUp;
  return STATUSES.inUse;
};
